import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"

interface SectionProps {
  title: string
  description?: string
  children: React.ReactNode
  id?: string
}

export function Section({ title, description, children, id }: SectionProps) {
  return (
    <section id={id} className="mb-12 scroll-mt-20">
      <Card>
        <CardHeader className="space-y-3 pb-6">
          <CardTitle className="text-3xl">{title}</CardTitle>
          {description && <CardDescription className="text-base">{description}</CardDescription>}
        </CardHeader>
        <CardContent className="space-y-6 pt-2">{children}</CardContent>
      </Card>
    </section>
  )
}

